import React from 'react'
import {connect} from 'react-redux'
import {Flex} from '/app/src/component'
import EmployeeSelector from '/app/src/model/Employee/selector'
import EmployeeModel from '/app/src/model/Employee/model'
import {SelectInput, TextInput} from '/app/src/component/Forms'
import {SVGButton} from '/app/src/component'
import style  from './style.css'

class Item extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            screen: 'normal',
            role: 'employee',
            username: '',
            email: ''
        }

        this._onChange = this._onChange.bind(this);
        this._renderNormalState = this._renderNormalState.bind(this);
        this._renderEditorState = this._renderEditorState.bind(this);
        this._handleQuickResponseEdit = this._handleQuickResponseEdit.bind(this);

        this._toEditor = this._toEditor.bind(this);
        this._toNormalState = this._toNormalState.bind(this);

        this._saveToDatabase = this._saveToDatabase.bind(this)
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.currentItem !== 0){
            this.setState({screen: 'normal'})
        }
    }

    _toEditor(){
        this.props._onClick() // from above, making sure we become element in focus in the list
        this.setState({screen: 'edit'})
    }

    _toNormalState(){
        this.setState({screen: 'normal'});
    }


    _handleQuickResponseEdit(event){
        this.setState({quickResponse: event.target.value})
    }

    _saveToDatabase(){
        this.props.dispatch(EmployeeModel.create(
            this.state.username, this.state.email, this.state.role
        ))
        this._toNormalState();
        this.setState({
            username: '',
            email: ''
        })
    }

    _renderNormalState(){
        return (
            <SVGButton
                height='70px'
                fontSize='26px'
                fontWeight='500'
                backgroundHover='lightblue'
                backgroundColor='darkwhite'
                borderRadius='60px'
                border='2px solid transparent'
                hoverBorder='2px solid #4ec1e9'
                src='/images/EmployeeAdd_M.svg'
                text='Lägg till medarbetare' color='grey'
                onClick={this._toEditor}/>
        )
    }
    _onChange(e){
        this.setState({[e.target.name]: e.target.value})
    }
    _renderEditorState(){
        return (
            <Flex width='100%' className={style.ItemEdit} grow basis='180px'>
                <Flex column grow>
                    <Flex className={style.ItemResponseBody} grow>
                        <Flex vAlignContent='center' hAlignContent='center' marginLeft='20px' marginRight='20px'>
                            <img
                                alt=''
                                width='70px'
                                height='70px'
                                src={EmployeeSelector.getImageUrl()}/>
                        </Flex>
                        <Flex column className={style.Info} w='100%'>
                            <Flex shrink={0}>
                                <Flex w='100%' column shrink={0}>
                                    <Flex shrink={0} className={style.Name} vAlignContent='center' marginBottom='20px'>
                                        <Flex w='100%'>
                                        <TextInput
                                            name='username'
                                            onChange={this._onChange}
                                            placeholder='Användarnamn'
                                            value={this.state.username}
                                        />
                                        </Flex>
                                        <Flex w='100%' hAlignContent='right'>
                                        <SelectInput select={this.state.role}
                                                values={{
                                                    admin: 'Admin',
                                                    manager: 'Manager',
                                                    employee: 'Employee'
                                                }}
                                                name='role'
                                                onChange={this._onChange}
                                        />
                                        </Flex>
                                    </Flex>
                                    <Flex w='50%' className={style.Email}>
                                        <TextInput
                                            name='email'
                                            onChange={this._onChange}
                                            placeholder='E-post'
                                            value={this.state.email}
                                        />
                                    </Flex>
                                    <Flex fontSize='18px' paddingTop="5px">
                                        Månadsavgift tillkommer. Läs mer på <a href="https://jibber.se/priser" rel="noopener noreferrer" target="_blank">vår hemsida</a>.
                                    </Flex>
                                </Flex>
                            </Flex>
                        </Flex>
                    </Flex>
                </Flex>

                <Flex hAlignContent='right' basis='100px'>
                    <Flex className={style.ItemOptions} column vAlignContent='center' hAlignContent='center'>

                        <SVGButton
                        onClick={this._toNormalState}
                        color='darkgrey' hover='blue'
                        src='/images/Return.svg'
                        />
                        <SVGButton
                        onClick={this._saveToDatabase}
                        color='darkgrey' hover='blue'
                        src='/images/Save.svg'
                        />
                    </Flex>
                </Flex>
            </Flex>
        )
    }

    render(){
        switch(this.state.screen){
            case 'edit':
                return this._renderEditorState()
            case 'normal':
            default:
                return this._renderNormalState(this.state.screen)
        }
    }
}



export default connect()(Item);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Employee/AddNewCoworker.js